import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const InlineBanner = styled.div`
  position: relative;
  clear: both;
  background: ${({ $bannerColor, theme }) =>
    ($bannerColor === 'default' && theme.palette.lightBackground) ||
    ($bannerColor === 'grey' && theme.palette.lightBackground) ||
    ($bannerColor === 'white' && theme.palette.white) ||
    ($bannerColor === 'transparent' && 'transparent')};

  padding-left: ${({ theme }) => theme.spacing.standard};
  padding-right: ${({ theme }) => theme.spacing.standard};
  padding-top: ${({ theme }) => theme.spacing.standard};
  margin-bottom: ${({ $removeMarginBottom, $sidebar, theme }) =>
    ($removeMarginBottom && '0') ||
    ($sidebar && theme.spacing.standard) ||
    theme.spacing.large};

  border-left: ${({ $borderColor }) =>
    ($borderColor === 'no-border' && '0 none') || '4px solid;'};

  border-color: ${({ $borderColor, theme }) =>
    ($borderColor === 'default' && theme.palette.brand) ||
    ($borderColor === 'red' && theme.palette.brand) ||
    ($borderColor === 'grey' && theme.palette.border) ||
    ($borderColor === 'warning' && theme.palette.errorBorder) ||
    ($borderColor === 'quick-exit-blue' && theme.palette.quickExitBlue) ||
    ($borderColor === 'facebook-blue' && theme.palette.socialFacebook) ||
    ($borderColor === 'twitter-blue' && theme.palette.socialTwitter) ||
    ($borderColor === 'whatsapp-green' && theme.palette.socialWhatsapp)};
`;

export const TextWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
`;

export const BannerSVG = styled(SVG)`
  fill: ${({ theme }) => theme.palette.standardText};
  width: ${({ $hasHeading }) => ($hasHeading ? '24px' : '18px')};
  height: ${({ $hasHeading }) => ($hasHeading ? '24px' : '18px')};
  margin-top: 4px;
  margin-right: 1em;
  display: inline-block;
  vertical-align: top;

  + div {
    width: calc(100% - 3em);
  }
`;
